var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"jobPreferences"}},[_c('div',{staticClass:"jobPreferencesTitle"},[_vm._v(" 求职偏好类型对比 ")]),_c('div',{staticClass:"chartInstanceBox"},[_c('div',{ref:"chartInstance",attrs:{"id":"chartInstance"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }